import { post } from 'axios'
import { jwtConfig } from 'helpers/RequestUtil'
import { delay } from 'redux-saga'
import {
  takeLatest,
  take,
  fork,
  all,
  call,
  select,
  put,
} from 'redux-saga/effects'

import {
  MOUNT,
  UNMOUNT,
  POST_PID_SYNC,
} from './constants'

import {
  startPostPidSyncAsync,
  postPidSyncStart,
  postPidSyncError,
  postPidSyncSuccess,
} from './actions'

import {
  clear,
} from 'containers/Admin/Product/ProductSelection/actions'

import {
  removeTables,
} from 'containers/Entity/actions'

function* handleMount() {
  yield put(clear())
  yield put(removeTables('skus'))
}

function* watchMount() {
  yield takeLatest(MOUNT, handleMount)
}

function* watchUnmount() {
  yield takeLatest(UNMOUNT, handleMount)
}

function* postPidSync() {
  try {
    yield put(startPostPidSyncAsync())
    yield put(postPidSyncStart())
    yield call(post, '/api/fulcrum/pid_syncs', {}, jwtConfig())
    yield call(delay, 25000)
    // make sure you can't call again for 25 sec (est. of how long PID takes)
    yield put(postPidSyncSuccess())
  } catch (error) {
    yield put(postPidSyncError(error))
  }
}

function* handlePidSync() {
  yield call(postPidSync)
}

function* watchPidSync() {
  yield takeLatest(POST_PID_SYNC, handlePidSync)
}

function* loadSagas() {
  yield all([
    fork(watchMount),
    fork(watchPidSync),
    fork(watchUnmount),
  ])
}

export default loadSagas
